const versionRegex = /_v[0-9]+$/i;

/**
 * Strips the version suffix (e.g. "_v2") from a service name.
 * Services can have versioned names like "zb_money_pro_v2" but
 * lookups (FAQs, trial eligibility, DNR configs, etc.) use the
 * versionless form "zb_money_pro".
 * @param {string} service
 * @returns {string}
 */
export default function getServiceVersionless(service) {
  if (!service) return '';
  return service.replace(versionRegex, '');
}
